import { PersonRelationshipViewModel, PersonRelationshipCreateCommand, PersonRelationshipUpdateCommand } from '../../models/Entities/Person/Relationship/PersonRelationshipModels';
import { ErrorType } from '../../models/HttpError';

export const PERSON_RELATIONSHIP_GETALL_REQUEST = 'PERSON_RELATIONSHIP_GETALL_REQUEST';
export const PERSON_RELATIONSHIP_GETALL_SUCCESS = 'PERSON_RELATIONSHIP_GETALL_SUCCESS';
export const PERSON_RELATIONSHIP_GETALL_FAILURE = 'PERSON_RELATIONSHIP_GETALL_FAILURE';

export interface PersonRelationshipGetAllRequestAction {
    type: typeof PERSON_RELATIONSHIP_GETALL_REQUEST;
    personId: number;
}

export interface PersonRelationshipGetAllSuccessAction {
    type: typeof PERSON_RELATIONSHIP_GETALL_SUCCESS;
    personId: number;
    payload: PersonRelationshipViewModel[];
}

export interface PersonRelationshipGetAllFailureAction {
    type: typeof PERSON_RELATIONSHIP_GETALL_FAILURE;
    error: ErrorType;
}

export const PERSON_RELATIONSHIP_GETBYID_REQUEST = 'PERSON_RELATIONSHIP_GETBYID_REQUEST';
export const PERSON_RELATIONSHIP_GETBYID_SUCCESS = 'PERSON_RELATIONSHIP_GETBYID_SUCCESS';
export const PERSON_RELATIONSHIP_GETBYID_FAILURE = 'PERSON_RELATIONSHIP_GETBYID_FAILURE';

export interface PersonRelationshipGetByIdRequestAction {
    type: typeof PERSON_RELATIONSHIP_GETBYID_REQUEST;
    id: number;
}

export interface PersonRelationshipGetByIdSuccessAction {
    type: typeof PERSON_RELATIONSHIP_GETBYID_SUCCESS;
    payload: PersonRelationshipViewModel;
}

export interface PersonRelationshipGetByIdFailureAction {
    type: typeof PERSON_RELATIONSHIP_GETBYID_FAILURE;
    error: ErrorType;
}

export const PERSON_RELATIONSHIP_CREATE_REQUEST = 'PERSON_RELATIONSHIP_CREATE_REQUEST';
export const PERSON_RELATIONSHIP_CREATE_SUCCESS = 'PERSON_RELATIONSHIP_CREATE_SUCCESS';
export const PERSON_RELATIONSHIP_CREATE_FAILURE = 'PERSON_RELATIONSHIP_CREATE_FAILURE';

export interface PersonRelationshipCreateRequestAction {
    type: typeof PERSON_RELATIONSHIP_CREATE_REQUEST;
    payload: PersonRelationshipCreateCommand;
}

export interface PersonRelationshipCreateSuccessAction {
    type: typeof PERSON_RELATIONSHIP_CREATE_SUCCESS;
    payload: PersonRelationshipViewModel;
}

export interface PersonRelationshipCreateFailureAction {
    type: typeof PERSON_RELATIONSHIP_CREATE_FAILURE;
    error: ErrorType;
}

export const PERSON_RELATIONSHIP_UPDATE_REQUEST = 'PERSON_RELATIONSHIP_UPDATE_REQUEST';
export const PERSON_RELATIONSHIP_UPDATE_SUCCESS = 'PERSON_RELATIONSHIP_UPDATE_SUCCESS';
export const PERSON_RELATIONSHIP_UPDATE_FAILURE = 'PERSON_RELATIONSHIP_UPDATE_FAILURE';

export interface PersonRelationshipUpdateRequestAction {
    type: typeof PERSON_RELATIONSHIP_UPDATE_REQUEST;
    payload: PersonRelationshipUpdateCommand;
}

export interface PersonRelationshipUpdateSuccessAction {
    type: typeof PERSON_RELATIONSHIP_UPDATE_SUCCESS;
    payload: PersonRelationshipViewModel;
}

export interface PersonRelationshipUpdateFailureAction {
    type: typeof PERSON_RELATIONSHIP_UPDATE_FAILURE;
    id: number;
    error: ErrorType;
}

export const PERSON_RELATIONSHIP_DELETE_REQUEST = 'PERSON_RELATIONSHIP_DELETE_REQUEST';
export const PERSON_RELATIONSHIP_DELETE_SUCCESS = 'PERSON_RELATIONSHIP_DELETE_SUCCESS';
export const PERSON_RELATIONSHIP_DELETE_FAILURE = 'PERSON_RELATIONSHIP_DELETE_FAILURE';

export interface PersonRelationshipDeleteRequestAction {
    type: typeof PERSON_RELATIONSHIP_DELETE_REQUEST;
    id: number;
}

export interface PersonRelationshipDeleteSuccessAction {
    type: typeof PERSON_RELATIONSHIP_DELETE_SUCCESS;
    id: number;
}

export interface PersonRelationshipDeleteFailureAction {
    type: typeof PERSON_RELATIONSHIP_DELETE_FAILURE;
    id: number;
    error: ErrorType;
}
